import $ from 'jquery';
import BaseView from 'picnic/core/views/Base';
import ShowMoreModel from 'app/cms/carcompanylist/views/ShowMoreModel';
import ShowMoreCompany from 'app/cms/carcompanylist/views/ShowMoreCompany';


class View extends BaseView {

	render() {
		super.render();

		this.$el.find('.company-wrapper').has('.toggle-car-list').each((index, el) => {
			new ShowMoreModel({
				el: $(el),
				context: this.context
			}).render();
		});

		new ShowMoreCompany({
			el: this.$el.children('div').first(),
			context: this.context
		}).render();

		return this;
	}

}

export default View;
